import * as React from 'react';
import { memo, ReactNode, useEffect } from 'react';

import { createPortal } from 'react-dom';

import { Modal } from 'atoms';

export interface IGlobalModalComponent {
  children: ReactNode;
  /**
   * The popup brings its own full-screen overlay (antd `<Modal>` or the `Modal`
   * atom) — render it bare, without a second scrim. See `SELF_CHROMED_POPUPS`.
   */
  bare?: boolean;
}

export const GlobalModalComponent = memo(
  ({ children, bare = false }: IGlobalModalComponent) => {
    /**
     * Блокировка прокрутки под попапом.
     *
     * 🔴 Закрываясь, ВОЗВРАЩАЕМ то, что было, а не выставляем `'auto'`.
     * Разница не косметическая: `antd` при открытии выдвижной панели тоже
     * запирает `body`, и попап, открытый ПОВЕРХ панели, своим `'auto'` снимал
     * её блокировку — страница под панелью снова прокручивалась. И даже без
     * панели `'auto'` навсегда прибивал к `body` стиль, которого там не было.
     *
     * Слепок вместо пустой строки по той же причине: чужую блокировку надо
     * вернуть как есть, а не стереть. Уборка живёт в возврате эффекта, значит
     * срабатывает и на размонтировании.
     */
    useEffect(() => {
      if (!children) return undefined;
      const previous = document.body.style.overflowY;
      document.body.style.overflowY = 'hidden';
      return () => {
        document.body.style.overflowY = previous;
      };
    }, [children]);

    if (!children) return null;

    return createPortal(
      bare ? <>{children}</> : <Modal>{children}</Modal>,
      document.body,
    );
  },
);
